<template>
  <div class="indexPage">
    <template v-if="!wapShow">
      <headers></headers>
      <el-carousel height="580px" class="banner-box">
        <el-carousel-item>
          <div class="app-content">
            <span class="homme-sp1" style="">四川交达预应力工程检测</span>
            <span class="homme-sp2" style="line-height: 2;">一家集检测服务、装备开发、科学研究和技术咨询业务为一体的专业预应力工程质量检测（监测）机构</span>
          </div>
          <img class="img" src="@/assets/imgs/home/13.png"/>
        </el-carousel-item>
        <el-carousel-item>
          <div class="app-content">
            <span class="homme-sp1" style="">开启全数量检测新模式</span>
            <span class="homme-sp2" style="line-height: 2;">中国最专业预应力工程全数字化技术服务平台，实现预应力检测及监测智能化、无人化、远程化、自动化4级进化</span>
          </div>
          <img class="img" src="@/assets/imgs/home/11.png"/>
        </el-carousel-item>
        <el-carousel-item>
          <div class="app-content">
            <span class="homme-sp1" style="">提升工程品质 杜绝安全隐患</span>
            <span class="homme-sp2" style="line-height: 2;">专注于预应力的研究实践，落实质量提升行动，引领行业持续、健康、高质量发展，创造更多、更大的价值</span>
          </div>
          <img class="img" src="@/assets/imgs/home/12.png"/>
        </el-carousel-item>

        <!--      <el-carousel-item >-->
        <!--        <div class="app-content" >-->
        <!--          <span class="homme-sp1" >让预应力更有效 让工程更可靠</span>-->
        <!--          <span class="homme-sp2"style="line-height: 2;">专注于预应力的研究实践，引领行业持续、健康、高质量发展，创造更多、更大的价值</span>-->
        <!--        </div>-->
        <!--        <img class="img" src="@/assets/imgs/home/14.png" />-->
        <!--      </el-carousel-item>-->
      </el-carousel>
      <div class="new-box app-content">
        <!--     <div class="new-header-img" @click="toPage(newList1)">-->
        <!--       <img :src="newList1.cover" style="width:100%;height:100%;object-fit: cover" />-->
        <!--       <div class="new-header-img-title">-->
        <!--         <p>{{newList1.title}}</p>-->
        <!--         <p style="margin-top: 21px">发布时间：{{newList1.publishDate}}</p>-->
        <!--       </div>-->
        <!--     </div>-->

<!--        <span class="h1">新闻中心</span>-->
<!--        <div class="new-content">-->
<!--          <div class="new-li" v-for="item in newList" @click="toPage(item)">-->
<!--            <p class="time1">{{getTimeMo(item.publishDate)}}</p>-->
<!--            <p class="time2">{{getTimeMo1(item.publishDate)}}</p>-->
<!--            <span class="new-span1">{{item.title}}</span>-->
<!--            <span class="new-span2" :title="item.subTitle">{{item.subTitle}}</span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div style="background-color: #ffffff">
        <div ref="testref" style="display: none" :class="{'title1':testShow}">交达预应力 - 预应力品质工程践行者</div>

        <div class="app-content home-content" ref="test2ref">
          <div class="li" :class="{'lis':testShow2}">
            <div class="background"></div>
            <img class="img1" src="@/assets/imgs/home/1-1.png"/>
            <span class="sp1">价值观</span>
            <span class="sp2">利他、专注、科技</span>
          </div>
          <div class="li" :class="{'lis':testShow2}">
            <div class="background"></div>
            <img class="img1" src="@/assets/imgs/home/1-2.png"/>
            <span class="sp1">使命</span>
            <span class="sp2">提升工程品质，杜绝质量隐患</span>
          </div>
          <div class="li" :class="{'lis':testShow2}">

            <div class="background"></div>
            <img class="img1" src="@/assets/imgs/home/1-3.png"/>
            <span class="sp1">愿景</span>
            <span class="sp2">全数量检测的引领者</span>
          </div>
        </div>

        <!--  <div class="product-box app-content">-->

        <!--    <span class="h1" ref="test4ref">产品与服务</span>-->
        <!--    <div class="flex-sp" style="margin-top: 64px">-->
        <!--      <div :class="li1Show?'product-li2':'product-li'" :style="{'display':testShow4?'block':'none'}" @mouseover="li1Show=true" @mouseout="li1Show=false">-->
        <!--        <template v-if="!li1Show">-->
        <!--        <img src="@/assets/imgs/home/2-2.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="@/assets/imgs/product/1.png" />-->
        <!--        </template>-->
        <!--         <span class="li-span" :style="{'color':li1Show?'#ffffff':''}">预应力工程全数量检测系统<br/>-->
        <!--               （PCS-UM20）</span>-->
        <!--        <span class="li-span2" :style="{'color':li1Show?'#ffffff':''}">面向基建领域的预应力工程提供基于物联网智能感知、大数据分析决策、云平台智慧协同的数字化施工质量监测与管控解决方案。</span>-->
        <!--      </div>-->
        <!--      <div :class="li2Show?'product-li2':'product-li'"  style="animation-delay: 0.5s"   :style="{'display':testShow4?'block':'none'}" @mouseover="li2Show=true" @mouseout="li2Show=false">-->
        <!--        <template v-if="!li2Show">-->
        <!--        <img src="@/assets/imgs/home/2-4.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="@/assets/imgs/product/3.png" style="    width: 313px;height: 186px;" />-->
        <!--        </template>-->
        <!--         <span class="li-span" :style="{'color':li2Show?'#ffffff':''}">锚下预应力检测系统<br/>（PT-20S）</span>-->
        <!--        <span class="li-span2" :style="{'color':li2Show?'#ffffff':''}">一种用于工后检测的锚下有效预应力检测设备。</span>-->
        <!--      </div>-->
        <!--      <div :class="li3Show?'product-li2':'product-li'" style="animation-delay: 1.5s" @mouseover="li3Show=true" @mouseout="li3Show=false"  :style="{'display':testShow4?'block':'none'}">-->
        <!--        <template v-if="!li3Show">-->
        <!--        <img src="@/assets/imgs/home/2-3.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="@/assets/imgs/product/4.png" style="width: 301px;height: 189px;" />-->
        <!--        </template>-->
        <!--         <span class="li-span" :style="{'color':li3Show?'#ffffff':''}">-->
        <!--           预应力锚索基础试验系统<br/>（PT-20C）-->
        <!--         </span>-->
        <!--        <span class="li-span2" :style="{'color':li3Show?'#ffffff':''}">一款经典的预应力锚索基础类试验系统。</span>-->
        <!--      </div>-->
        <!--    </div>-->
        <!--    <div class="flex-sp" style="margin-top: 20px">-->
        <!--      <div :class="li4Show?'product-li2':'product-li'"  @mouseover="li4Show=true" @mouseout="li4Show=false"  style="animation-delay: 2.5s;"  :style="{'display':testShow4?'block':'none','width':li4Show?'':'592px','max-width':li4Show?'':'592px'}">-->
        <!--         <span class="li-span" :style="{'color':li4Show?'#ffffff':''}">-->
        <!--           智能拉拔系统（PT-20M）-->
        <!--         </span>-->
        <!--        <span class="li-span2" :style="{'color':li4Show?'#ffffff':''}">一款先进的预应力锚索拉拔设备。</span>-->
        <!--        <template v-if="!li4Show">-->
        <!--        <img src="@/assets/imgs/home/2-5.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="@/assets/imgs/product/2.png" style="width: 422px;height: 245px;" />-->
        <!--        </template>-->
        <!--      </div>-->

        <!--      <div :class="li5Show?'product-li2':'product-li'" @mouseover="li5Show=true" @mouseout="li5Show=false" style="animation-delay: 2.5s"  :style="{'display':testShow4?'block':'none','width':li5Show?'':'592px','max-width':li5Show?'':'592px'}">-->
        <!--        <template v-if="!li5Show">-->
        <!--           <img src="@/assets/imgs/home/2-1.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="@/assets/imgs/product/5.png" style="width: 324px;height: 325px;"/>-->
        <!--        </template>-->
        <!--         <span class="li-span" :style="{'color':li5Show?'#ffffff':''}">-->
        <!--          远程监测系统<br/>（JD-FAST21）-->
        <!--         </span>-->
        <!--        <span class="li-span2" :style="{'color':li5Show?'#ffffff':''}">一款通用化的岩土工程传感器远程采集传输设备。</span>-->
        <!--      </div>-->
        <!--    </div>-->

        <!--  </div>-->
        <div class="app-content">
          <!--        <p class="box3-title">业务体系</p>-->
          <span class="box3-detail">  四川交达在公路、铁路、市政、水利、矿山、地产等基建行业，对于广泛采用预应力技术的桥梁、边坡、隧道、基坑、巷道、建筑等重大基础设施工程结构，针对客户与合作伙伴（行政主管部门、建设单位、施工单位、监理单位等各方）在建设过程中长期面临的质量安全上的控制难、损失大、风险高、责任重等问题，为客户提供特色检（监）测、特殊试验、科研项目、产品研发、技术咨询、数据服务、技术培训等类型的相关业务。</span>

        </div>

        <div class="inRegard-box3">
          <div class="app-content" style="position: relative">
            <img src="@/assets/imgs/inRegard/1.png"/>
            <!--            <div class="inRegard-box3-title">-->
            <!--              依托 <span style="color: #0071EF">1 套</span>重大创新技术体系-->
            <!--              【全数量检测】</div>-->
          </div>
        </div>
        <div class="technological-box6">
          <div class="app-content" style="position: relative;    overflow: initial;">
            <p class="box6-title">技术创新</p>
            <p class="box6-title1">截至2022年7月</p>
            <p class="box6-title2">公司申请专利</p>
            <p class="box6-title3">50<span style="margin-left: 20px;font-size: 40px">项</span></p>
            <p class="box6-line"></p>
            <div class="box6-box1 flex-sp ">
              <div class="box6-li">
                <p class="li6-1">发明专利</p>
                <p class="li6-2">25<span style="font-size: 36px;margin-left: 10px">项</span></p>
              </div>
              <div class="box6-li">
                <p class="li6-1">实用新型</p>
                <p class="li6-2">20<span style="font-size: 36px;margin-left: 10px">项</span></p>
              </div>
              <div class="box6-li">
                <p class="li6-1">软件著作</p>
                <p class="li6-2">5<span style="font-size: 36px;margin-left: 10px">项</span></p>
              </div>
            </div>
            <img class="technological-box6-img" src="@/assets/imgs/technological/23.png"/>
            <div class="box-img flex">
              <div style="margin-top: 112px">
                <img src="@/assets/imgs/technological/9.png"/>
                <img src="@/assets/imgs/technological/10.png"/>
                <img src="@/assets/imgs/technological/11.png"/>
              </div>
              <div style="margin-top: 112px">
                <img src="@/assets/imgs/technological/12.png"/>
                <img src="@/assets/imgs/technological/1.jpg"/>
                <img src="@/assets/imgs/technological/2.jpg"/>
              </div>
              <div style="margin-top: 162px">
                <img src="@/assets/imgs/technological/3.jpg"/>
                <img src="@/assets/imgs/technological/4.jpg"/>
                <img src="@/assets/imgs/technological/5.jpg"/>
              </div>
              <div>
                <img src="@/assets/imgs/technological/18.png"/>
                <img src="@/assets/imgs/technological/19.png"/>
                <!--            <img src="@/assets/imgs/technological/20.jpg" />-->
              </div>
            </div>
          </div>
        </div>

        <div class="app-content cooperation-box">
          <span class="h1">合作伙伴</span>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/1.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/2.png"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/3.png"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/4.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/5.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/6.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/7.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/8.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/9.jpg"/>
              </div>
              <div class="swiper-slide">
                <img src="@/assets/imgs/logo/10.jpg"/>
              </div>
            </div>
            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>

      </div>
      <footers></footers>
    </template>

    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>
<script type="text/javascript">

  import headers from "@/components/header"
  import footers from "@/components/footers"
  import axios from "axios";
  import eventBus from "../assets/js/eventBus";
  import wapIndex from "./wapIndex"
  import Swiper,{Autoplay}from "swiper"
  Swiper.use([Autoplay]);
  export default {
    name: 'index',
    components: {headers, footers, wapIndex},
    data() {
      return {
        newList: [],
        testShow: true,
        testShow2: false,
        testShow3: false,
        testShow4: false,
        testShow5: false,
        li1Show: false,
        li2Show: false,
        li3Show: false,
        li4Show: false,
        li5Show: false,
        newList1: {
          publishDate: "",
          title: "",
          cover: "",
        },
        wapShow: true
      }
    },
    mounted() {
      this.getNewsList();
      this.$nextTick(() => {
        this.handleScrollbox();

    })
      eventBus.$on("wapShow", (data) => {
        this.wapShow = data;
        if (!this.wapShow) {
          this.$nextTick(()=>{
            this.mySwiper = new Swiper('.swiper-container', {
              direction:'horizontal',
              speed: 400,
              observer:true,//修改swiper自己或子元素时，自动初始化swiper
              observeParents:true,//修改swiper的父元素时，自动初始化swiper
              loop:true,
              slidesPerView: 6, // 显示几个
              autoplay : {
                delay : 1000, //自动切换的时间间隔，单位ms
                disableOnInteraction : false //用户操作swiper之后，是否禁止autoplay
              },
            })
          })
          window.addEventListener('scroll', this.handleScrollbox, true);
        }
      })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    },
    methods: {
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        if (this.$refs.testref) {
          if (this.currentScroll >= this.$refs.testref.offsetTop - 700) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow = true
          }
        }
        if (this.$refs.test2ref) {
          if (this.currentScroll >= this.$refs.test2ref.offsetTop - 600) {
            this.testShow2 = true
          }
        }
        if (this.$refs.test3ref) {
          if (this.currentScroll >= this.$refs.test3ref.offsetTop - 450) {
            this.testShow3 = true
          }
        }
        if (this.$refs.test4ref) {
          if (this.currentScroll >= this.$refs.test4ref.offsetTop - 450) {
            this.testShow4 = true
          }
        }
      },
      getNewsList() {
        axios.get(this.pageUrl + `/news/page?pageNo=1&pageSize=6`).then(res => {
          this.newList1 = res.data.data.list[0];
          this.newList = res.data.data.list.slice(0, res.data.data.list.length);
        })
      },
      toPage(data) {
        if (data.type == 'outer') {
          window.open(data.url)
        } else if (data.type == 'inner') {
          this.$router.push({
            path: '/newsDetail',
            query: {
              id: data.id
            }
          })
        }
      },
      getTimeMo(str) {
        if (str) {
          if (typeof str == "string") {
            str = str.replace(/-/g, '/');
          }
          let t1 = new Date(str)

          return t1.getDate() < 10 ? ('0' + t1.getDate()) : t1.getDate()
        }

        return ""
      },

      getTimeMo1(str) {
        if (str) {
          if (typeof str == "string") {
            str = str.replace(/-/g, '/');
          }
          let t1 = new Date(str)

          return t1.getFullYear() + "." + ((t1.getMonth() + 1) < 10 ? ('0' + (t1.getMonth() + 1)) : (t1.getMonth() + 1))
        }

        return ""
      }
    },
  }
</script>
<style>
  .banner-box .is-active .el-carousel__button {
    background: linear-gradient(147deg, #34E4AA 0%, #2C68FF 100%);
  }
</style>
<style scoped>
  .cooperation-box{
    overflow: hidden;
    padding: 40px 0;
  }
  .cooperation-box .swiper-container {
    height: 140px;
  }
  .cooperation-box .swiper-slide{
    padding-right: 20px;
    box-sizing: border-box;
  }
  .cooperation-box .swiper-container img{
    width: 100%;
    object-fit: contain;
    height: 100%;
  }
  .banner-box .img {
    background: #19203B;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .banner-box .homme-sp1 {
    font-size: 38px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    color: #19203B;
    transform: translateX(0px);
    position: absolute;
    top: 147px;
    z-index: 999;
    left: 0;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    font-weight: bold;
    letter-spacing: 6px;
    animation-timing-function: ease;
    animation-fill-mode: forwards;

  }

  .banner-box .homme-sp2 {
    position: absolute;
    top: 267px;
    left: 0;
    letter-spacing: 4px;
    width: 700px;
    z-index: 999;
    height: 98px;
    font-size: 24px;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 1s;
    animation-fill-mode: forwards;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgba(92, 93, 95, 1);
  }

  .title1 {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    display: block !important;
    letter-spacing: 5px;
    text-align: center;
    margin: 40px 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    visibility: visible;

  }

  .home-content {
    display: flex;
    justify-content: space-between;

  }

  .home-content .li {
    width: 389px;
    height: 266px;
    position: relative;
    z-index: 1;
    text-align: center;
    margin-bottom: 40px;

  }

  .home-content .lis {
    animation-name: fadeInLeft;
    animation-duration: 2s;
  }

  .home-content .li .background {
    width: 100%;
    height: 100%;
    border-radius: 4px 4px 4px 4px;
    background-color: #F1F3F9;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .home-content .li .img1 {
    width: 140px;
    height: 140px;
    display: block;
    margin: 0 auto 0;
  }

  .home-content .li .sp1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    margin: 4px auto 0;
    display: block;
    color: #19203B;

  }

  .home-content .li .sp2 {
    margin: 20px auto 0;
    display: block;
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
  }

  .home-content .li:hover .background {
    background: linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);
    animation: gradientBG 3s ease forwards;

  }

  .detail-box {
    animation-name: fadeInLeft;
    animation-duration: 2s;
  }

  .detail-box .ts {
    display: block !important;
    animation-name: fadeInUp;
    animation-duration: 1s;
  }

  .detail-box .t1 {
    display: none;
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 10px;
  }

  .detail-box .t2 {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    display: none;
    margin-bottom: 32px;
    word-break: break-word;
    letter-spacing: 2px;
  }

  .map-box {
    height: 820px;
    border-radius: 0px 0px 0px 0px;
    background-image: url("../assets/imgs/home/9.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .map-box .map-box-text {
    padding-top: 101px;
  }

  .map-box .map-box-text .map-box-li {
    margin-bottom: 32px;
  }

  .map-box img {
    width: 650px;
    height: 500px;
    margin-right: 130px;
    margin-top: 150px;
  }

  .map-box .map-box-text .map-box-li span {
    font-size: 44px;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    color: #0071EF;
    letter-spacing: 2px;
  }

  .map-box .map-box-text .map-box-li p {
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
  }

  .product-box {
    padding: 40px 0;
  }
  .cooperation-box .h1 {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    display: block;
    text-align: center;
    margin-bottom: 40px;
    letter-spacing: 4px;
  }
  .product-box .h1, .new-box .h1 {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    display: block;
    text-align: center;
    letter-spacing: 4px;
  }

  .product-box .product-li {
    max-width: 389px;
    height: 373px;
    margin-right: 20px;
    background: #F1F3F9;
    border-radius: 4px 4px 4px 4px;
    padding: 40px 51px 51px;
    box-sizing: border-box;
    animation-name: fadeInUp;
    opacity: 0;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    position: relative;
  }

  .product-box .product-li img {
    position: absolute;
    width: 100px;
    right: 0;
    bottom: 0;
  }

  .product-box .product-li .li-span, .product-box .product-li2 .li-span {
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: left;
    display: block;
  }

  .product-box .product-li .li-span img {
    width: 536px;
    height: 306px;
    position: absolute;
    right: 0;
    bottom: 0;
    object-fit: cover;
  }

  .product-box .product-li .li-span2, .product-box .product-li2 .li-span2 {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 36px;
    letter-spacing: 1px;
    margin-top: 20px;
    display: block;
  }

  .product-box .product-li2 img {
    width: 193px;
    height: 166px;
    position: absolute;
    right: 0;
    bottom: 0;
    object-fit: cover;
  }

  .product-box .product-li2 {
    width: 794px;
    height: 372px;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    background: #181C25;
    padding: 40px 51px 51px;
    border-radius: 4px 4px 4px 4px;
    box-sizing: border-box;
    position: relative;
    margin-right: 20px;
  }


  .new-box {
    padding-top: 40px;
  }

  .new-box .new-header-img {
    width: 100%;
    height: 510px;
    position: relative;
    margin-bottom: 40px;
  }

  .new-box .new-header-img-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 124px;
    font-size: 18px;
    padding: 32px 39px;
    background: rgb(255 255 255 / 40%);
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    backdrop-filter: blur(20px);
    box-sizing: border-box;
  }

  .new-box .new-content .new-li {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 49px 0 120px;
    height: 100px;
    margin-top: 20px;
    background: #F1F3F9;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-bottom: 19px;
    cursor: pointer;
    position: relative;
  }

  .new-box .new-content .new-li .time1 {
    font-size: 44px;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    color: #0071EF;
    position: absolute;
    top: 5px;
    left: 43px;
  }

  .new-box .new-content .new-li .time2 {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    position: absolute;
    top: 68px;
    left: 45px;
  }

  .new-box .new-content .new-li:hover {
    background: linear-gradient(147deg, #34E4AA 0%, #2C68FF 100%);
  }

  .new-box .new-content .new-li:hover .new-span2, .new-box .new-content .new-li:hover .new-span1, .new-box .new-content .new-li:hover .time1, .new-box .new-content .new-li:hover .time2 {
    color: #FFFFFF;
  }

  .new-box .new-content .new-span1 {
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    display: block;
  }

  .new-box .new-content .new-span2 {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 24px;
    display: block;
    margin-top: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .inRegard-box3 {
    background: #F2F4F9;
    width: 100%;
    padding-bottom: 60px;
    position: relative;
  }

  .inRegard-box3-title {
    position: absolute;
    font-size: 36px;
    width: 464px;
    text-align: center;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    top: 95px;
    left: 496px;
    line-height: 2;
    color: #19203B;
  }

  .box3-title {
    padding-top: 64px;
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }

  .box3-detail {
    font-size: 20px;
    letter-spacing: 4px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    letter-spacing: 1px;
    line-height: 2;
    margin-top: 40px;
    margin-bottom: 40px;
    display: block;
  }

  .inRegard-box3 img {
    width: 100%;
    margin-top: 64px;
  }

  .technological-box6 {
    margin-top: 100px;
    width: 100%;
    overflow: hidden;
    padding-bottom: 128px;
    height: 1000px;
  }

  .technological-box6 .box-img {
    position: absolute;
    top: 0;
    width: 860px;
    right: -300px;
  }

  .technological-box6 .box-img img {
    width: 217.62px;
  }

  .technological-box6 .box6-title {
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-title1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 131px;
  }

  .technological-box6 .box6-title2 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0071EF;
    margin-top: 41px;
  }

  .technological-box6 .box6-title3 {
    font-size: 80px;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #0071EF;
    margin-top: 71px;
  }

  .technological-box6 .box6-line {
    width: 570px;
    height: 2px;
    background: #5C5D5F;
    margin-top: 90px;
  }

  .technological-box6 .box6-box1 {
    margin-top: 41px;
    width: 560px;
  }

  .technological-box6 .box6-box1 .li6-1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-box1 .li6-2 {
    font-size: 50px;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #19203B;
    margin-top: 33px;
  }

  .technological-box6-img {
    position: absolute;
    width: 600px;
    right: -70px;
    top: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue